"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/external-card-payout.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fexternal-card-payout.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.payoutStatusToJSON = exports.payoutStatusFromJSON = exports.payoutMethodToJSON = exports.payoutMethodFromJSON = exports.PayoutStatus = exports.PayoutMethod = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.payout.proto';
/**
 * Provider (Stripe) payout methods for external card.
 */
var PayoutMethod;
(function (PayoutMethod) {
    PayoutMethod["INVALID_AVAILABLE_PAYOUT_METHOD"] = "INVALID_AVAILABLE_PAYOUT_METHOD";
    /**
     * STANDARD - Default payout speed defined by card acquiring provider payout schedule.
     */
    PayoutMethod["STANDARD"] = "STANDARD";
    /**
     * INSTANT - For supported debit cards, allows paying out within 30 minutes.
     */
    PayoutMethod["INSTANT"] = "INSTANT";
    PayoutMethod["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PayoutMethod || (exports.PayoutMethod = PayoutMethod = {}));
/**
 * Provider (Stripe) status for payout to external card.
 */
var PayoutStatus;
(function (PayoutStatus) {
    PayoutStatus["INVALID_PAYOUT_STATUS"] = "INVALID_PAYOUT_STATUS";
    /**
     * PENDING - Payouts are pending until it is submitted to the bank
     */
    PayoutStatus["PENDING"] = "PENDING";
    /**
     * IN_TRANSIT - When the payout is submitted to the bank
     */
    PayoutStatus["IN_TRANSIT"] = "IN_TRANSIT";
    /**
     * CANCELED - When the payout is cancelled.
     */
    PayoutStatus["CANCELED"] = "CANCELED";
    /**
     * FAILED - When the payout has failed.
     */
    PayoutStatus["FAILED"] = "FAILED";
    /**
     * PAID - When the payout has been paid and expected to be available on the destination account.
     */
    PayoutStatus["PAID"] = "PAID";
    PayoutStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PayoutStatus || (exports.PayoutStatus = PayoutStatus = {}));
function payoutMethodFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_AVAILABLE_PAYOUT_METHOD':
            return PayoutMethod.INVALID_AVAILABLE_PAYOUT_METHOD;
        case 1:
        case 'STANDARD':
            return PayoutMethod.STANDARD;
        case 2:
        case 'INSTANT':
            return PayoutMethod.INSTANT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PayoutMethod.UNRECOGNIZED;
    }
}
exports.payoutMethodFromJSON = payoutMethodFromJSON;
function payoutMethodToJSON(object) {
    switch (object) {
        case PayoutMethod.INVALID_AVAILABLE_PAYOUT_METHOD:
            return 'INVALID_AVAILABLE_PAYOUT_METHOD';
        case PayoutMethod.STANDARD:
            return 'STANDARD';
        case PayoutMethod.INSTANT:
            return 'INSTANT';
        case PayoutMethod.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.payoutMethodToJSON = payoutMethodToJSON;
function payoutStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PAYOUT_STATUS':
            return PayoutStatus.INVALID_PAYOUT_STATUS;
        case 1:
        case 'PENDING':
            return PayoutStatus.PENDING;
        case 2:
        case 'IN_TRANSIT':
            return PayoutStatus.IN_TRANSIT;
        case 3:
        case 'CANCELED':
            return PayoutStatus.CANCELED;
        case 4:
        case 'FAILED':
            return PayoutStatus.FAILED;
        case 5:
        case 'PAID':
            return PayoutStatus.PAID;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PayoutStatus.UNRECOGNIZED;
    }
}
exports.payoutStatusFromJSON = payoutStatusFromJSON;
function payoutStatusToJSON(object) {
    switch (object) {
        case PayoutStatus.INVALID_PAYOUT_STATUS:
            return 'INVALID_PAYOUT_STATUS';
        case PayoutStatus.PENDING:
            return 'PENDING';
        case PayoutStatus.IN_TRANSIT:
            return 'IN_TRANSIT';
        case PayoutStatus.CANCELED:
            return 'CANCELED';
        case PayoutStatus.FAILED:
            return 'FAILED';
        case PayoutStatus.PAID:
            return 'PAID';
        case PayoutStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.payoutStatusToJSON = payoutStatusToJSON;
//# sourceMappingURL=external-card-payout.js.map